import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import { SpinnerContext } from '../../../context/spinnerContext'
import { acceptExtensions } from '../../../helper/function'
import { IMAGE_MODULE } from '../../../util/constant'
import { addExtraDocument } from '../../../redux/slices/cleanersSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { addDocumentSchema } from '../../../util/validationSchema'
import DropzoneController from '../../../component/dropzone'

const AddDocuments = ({ toggleAddDocumentModal, setIsRefresh, cleaner_id }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(addDocumentSchema),
    defaultValues: {}
  })

  const onSubmit = (data) => {
    const payload = {
      id: cleaner_id,
      data: {
        documents: data?.images?.map((url) => ({
          s3Url: url
        }))
      }
    }

    setIsRefresh(false)
    changeLoader(true)
    dispatch(addExtraDocument(payload)).then(({ payload, error }) => {
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Success!')
        setIsRefresh(true)
        changeLoader(false)
        toggleAddDocumentModal()
        reset()
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Upload Photos <span className="text-danger"> *</span>
              </label>
              <DropzoneController
                name="images"
                maxFiles={10}
                acceptExtensions={acceptExtensions}
                control={control}
                files={watch('images') || []}
                module={IMAGE_MODULE.CLEANER}
                isEditImage={true}
                isAddMode={true}
              />
              <small>{errors?.images?.message}</small>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleAddDocumentModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddDocuments
